import React, { useState, useEffect } from 'react';
import useTabs from 'hooks/useTabs';
import { Tab, Tabs, TabList, TabPanel } from 'components/Tabs';
import __ from 'localisation';
import { useMiddleman } from '@hubins/middleman';
import Heading from '@hubins/components/Heading';
import { LoadingBox } from '@hubins/components/LoadingIndicators';
import Icon from '@hubins/components/IconNew';
import Registration from './Registration';
import AptitudeTests from 'views/Client/AptitudeTests';
import Overview from './Overview';
import DeleteProfileButton from '@hubins/components/DeleteProfileButton';
import { isBackofficeUser, isAdmin } from 'helpers/userRoles';
import Screening from 'views/Client/Screening';
import PhoneAuthBankId from 'views/PhoneAuthBankId';

const tabs = [
  'overview',
  'registration',
  'aptitude_tests',
  'screening',
  'bankid'
]

const Profile = ({ match, location, userRoles }) => {
  const middleman = useMiddleman();

  const [index, setIndex] = useState(0);
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true)

  const { profileUuid } = match.params;

  const backOfficeUser = isBackofficeUser(userRoles);
  const admin = isAdmin(userRoles);

  const fetchProfile = async () => {
    try {
      const res = await middleman.get(`/profile/${profileUuid}`);
      setProfile(res.data);
      setLoading(false);
    } catch (e) {
      console.error('error fetching profile', e);
    }
  }

  useEffect(() => {
    fetchProfile();
  }, [])

  useTabs(setIndex, index, tabs)

  if (loading) {
    return <LoadingBox />
  }

  return (
    <>
      <Heading size="2">
        {profile.name}
      </Heading>
      <div className="flex flex--row align-items-center s-top-lg">

        <Icon title="name" icon="user" size={16} className="s-right-s" />
        {profile.name}

        <Icon title="ssn" icon="Touch Id 1" size={16} className="s-right-s s-left-m" />
        {profile.national_identity_number}
        {admin && (
          <div className="flex-grow align-right">
            <DeleteProfileButton profileUuid={profileUuid} />
          </div>
        )}
      </div>
      <hr />
      <Tabs
        className="line-tabs"
        selectedTabClassName="line-tabs__tab--selected"
        selectedTabPanelClassName="line-tabs__tab-panel--selected"
        onSelect={setIndex}
        selectedIndex={index}
      >
        <TabList className="line-tabs__tab-list">
          <Tab className="heading heading--5 line-tabs__tab">{__('overview')}</Tab>
          <Tab className="heading heading--5 line-tabs__tab">{__('registration')}</Tab>
          <Tab className="heading heading--5 line-tabs__tab">{__('aptitude_tests')}</Tab>
          {backOfficeUser && (
            <>
              <Tab className="heading heading--5 line-tabs__tab">{__('screening')}</Tab>
              <Tab className="heading heading--5 line-tabs__tab">{__('bankid')}</Tab>
            </>
          )}
        </TabList>
        <TabPanel className="line-tabs__tab-panel">
          <div className="line-tabs__tab-content">
            <Overview profile={profile} backOfficeUser={backOfficeUser} />
          </div>
        </TabPanel>
        <TabPanel className="line-tabs__tab-panel">
          <div className="line-tabs__tab-content">
            <Registration
              profileUuid={profileUuid}
              nationalIdentityNumber={profile.national_identity_number}
              isCompany={profile.type === 'COMPANY'}
              profile={profile}
            />
          </div>
        </TabPanel>
        <TabPanel className="line-tabs__tab-panel">
          <div className="line-tabs__tab-content">
            <AptitudeTests client={profile} />
          </div>
        </TabPanel>
        {backOfficeUser && (
          <>
          <TabPanel className="line-tabs__tab-panel">
            <div className="line-tabs__tab-content">
              <Screening client={profile} />
            </div>
          </TabPanel>
          <TabPanel className="line-tabs__tab-panel">
            <div className="line-tabs__tab-content">
              <PhoneAuthBankId nationalIdentityNumber={profile.national_identity_number} />
            </div>
          </TabPanel>
          </>
        )}
      </Tabs>
    </>
  )

};

export default Profile;